import { useState } from "react";

const useEmployeeFilters = () => {
  const [activeFilter, setActiveFilter] = useState({});

  const updateFilter = (key, value) => {
    if (key === "response" && activeFilter[key] === value) {
      const { [key]: removed, ...rest } = activeFilter;
      setActiveFilter(rest);
    } else {
      setActiveFilter((prev) => ({ ...prev, [key]: value }));
    }
  };

  const clearFilters = () => setActiveFilter({});

  return { activeFilter, updateFilter, clearFilters };
};

export default useEmployeeFilters;
